module.exports = __webpack_public_path__ + "media/images/smiley-board-director 2-f2d498de93e5747688961fe977623409.png";